import classNames from 'classnames'
import Type from '../Type'

interface Props {
  children: React.ReactNode | string
  className?: string
}

const Lozenge: React.FC<Props> = ({ children, className }) => {
  return (
    <Type
      as="span"
      variant={['eyebrow-sm', 'md:eyebrow-md']}
      className={classNames(
        'rounded-md bg-core-gray-200 py-0.5 px-3 font-semibold text-core-gray-800',
        className
      )}
    >
      {children}
    </Type>
  )
}

export default Lozenge
